import {TPA_CONSTANTS} from '@wix/document-manager-utils'

export default TPA_CONSTANTS
